import React from 'react';

import Button from '@atlaskit/button';

const ButtonLinkExample = (): React.JSX.Element => {
	return <Button appearance="link">Link button</Button>;
};

export default ButtonLinkExample;
